import { GetterTree } from 'vuex';
import ApplicationsType from './applicationsStateType.type';

export const getters: GetterTree<ApplicationsType, any> = {
  searchedApplicationName: (state) => state.searchedApplicationName,
  applicationsList: (state) => state.applicationsList,
  filteredApplicationsList: (state) => state.filteredApplicationsList,
};
